import { useState } from 'react';

const ImageGallery = ({ images = [] }) => {
  const [currentImage, setCurrentImage] = useState(0);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const previousImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  // Pokud nejsou žádné obrázky, zobrazíme placeholder
  if (images.length === 0) {
    images = ['https://placehold.co/600x400'];
  }

  return (
    <div className="flex gap-4 bg-gray-800 p-4 rounded-lg">
      {/* Thumbnail Strip */}
      <div className="flex flex-col gap-2">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setCurrentImage(index)}
            className={`relative flex-none transition-all duration-200 ${
              currentImage === index 
                ? 'ring-2 ring-blue-500 shadow-lg shadow-blue-500/50' 
                : 'hover:ring-2 hover:ring-blue-500/50'
            }`}
          >
            <img
              loading="lazy"
              src={image}
              alt={`Náhled ${index + 1}`}
              className="h-16 w-16 rounded object-cover"
            />
            {currentImage === index && (
              <div className="absolute inset-0 bg-blue-500/20 rounded"></div>
            )}
          </button>
        ))}
      </div>

      {/* Main Image */}
      <div className="relative flex-grow">
        <div className="relative aspect-[4/3] w-full overflow-hidden rounded-lg bg-gray-700">
          <img
            loading="lazy"
            src={images[currentImage]}
            alt={`Obrázek vozidla ${currentImage + 1}`}
            className="h-full w-full object-cover transition-opacity duration-300"
          />
          <button
            className="absolute right-2 top-2 rounded-full bg-gray-900/70 p-2 text-white 
                       hover:bg-gray-900/90 transition-colors duration-200"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-5v4m0-4h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5" />
            </svg>
          </button>
        </div>

        {/* Navigation Arrows */}
        <button
          className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-gray-900/70 p-3 
                     text-white hover:bg-gray-900/90 transition-colors duration-200 
                     hover:scale-110 transform"
          onClick={previousImage}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-gray-900/70 p-3 
                     text-white hover:bg-gray-900/90 transition-colors duration-200 
                     hover:scale-110 transform"
          onClick={nextImage}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Image Counter */}
        <div className="absolute bottom-2 right-2 bg-gray-900/70 px-3 py-1 rounded-full text-white text-sm">
          {currentImage + 1} / {images.length}
        </div>
      </div>
    </div>
  );
};

export default ImageGallery; 